function modelsFor(data, make) {
  return data.filter(row => row.make === make && /^\/products\/[^/?#]+-car-window-shades$/.test(row.url)).sort((a,b) => (a.model || '').localeCompare(b.model || ''));
}
if (typeof module !== 'undefined') module.exports = { modelsFor };
if (typeof document !== 'undefined') {
  const dialog = document.getElementById('CscCarPicker');
  if (dialog && !dialog.dataset.ready) {
    dialog.dataset.ready = 'true';
    const make = dialog.querySelector('#CscPickerMake');
    const model = dialog.querySelector('#CscPickerModel');
    const submit = dialog.querySelector('[type="submit"]');
    const status = dialog.querySelector('[aria-live]');
    let data = [];
    try { data = JSON.parse(dialog.querySelector('[data-picker-data]').textContent); } catch (_) { status.textContent = 'Please use Browse all car makes below.'; }
    [...new Set(data.map(row => row.make))].sort((a,b)=>a.localeCompare(b)).forEach(value => make.add(new Option(value,value)));
    make.addEventListener('change', () => {
      model.replaceChildren(new Option('Select model',''));
      const rows = modelsFor(data,make.value);
      rows.forEach(row => model.add(new Option(row.model,row.url)));
      model.disabled = rows.length === 0; submit.disabled = true;
      submit.dataset.ready = 'false';
      status.textContent = ''; 
      if (rows.length) model.focus();
    });
    model.addEventListener('change', () => {
      submit.disabled = !model.value;
      submit.dataset.ready = String(!submit.disabled);
      if (!submit.disabled) submit.focus();
    });
    dialog.querySelector('form').addEventListener('submit', event => {
      event.preventDefault();
      if (modelsFor(data,make.value).some(row => row.url === model.value)) window.location.assign(model.value);
    });
    let opener;
    const open = source => {
      if (dialog.open) return;
      opener = source || document.activeElement;
      dialog.showModal(); document.documentElement.classList.add('csc-picker-open'); make.focus();
    };
    dialog.querySelector('.csc-car-picker__close').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
    dialog.addEventListener('close',()=>{
      document.documentElement.classList.remove('csc-picker-open');
      const url=new URL(window.location.href);url.searchParams.delete('choose-car');history.replaceState(history.state,'',url);
      opener?.focus();
    });
    document.addEventListener('click',event=>{
      const link=event.target.closest('a[href]');if(!link)return;
      const url=new URL(link.href,window.location.href);
      if(url.origin===location.origin && url.searchParams.has('choose-car')){event.preventDefault();open(link);}
    });
    if(new URLSearchParams(location.search).has('choose-car'))open();
  }
}
